import React from 'react'

import { Stack } from 'primitives/containers'

export type TimelineContentProps = {
  avatar?: React.ReactElement | React.ReactNode
  timelineInfo?: React.ReactElement | React.ReactNode
  as?: any
} & React.HTMLAttributes<HTMLDivElement> &
  React.ComponentProps<typeof Stack>

export const TimelineContent = React.forwardRef<
  HTMLDivElement,
  TimelineContentProps
>(({ children, avatar, timelineInfo, ...props }, ref) => (
  <Stack
    direction="row"
    css={{
      width: '100%',
      alignItems: 'flex-start',
    }}
    {...props}
    ref={ref}
  >
    {avatar}
    <Stack className="content" gap="1" css={{ width: '100%' }}>
      {timelineInfo}
      {children}
    </Stack>
  </Stack>
))

TimelineContent.displayName = 'TimelineContent'
